import { Events } from "../../share/Event"
import { register } from "./register"

export const eventInit = () => {
}

export const MaxEvent = () => {
  const {
    send,
    registerAppEvent,
    unregisterAppEvent,
    onDispose,
  } = register()
  return new Events({
    emit: send,
    registerAppEvent,
    unregisterAppEvent,
    onDispose,
  })
}
export const event = MaxEvent()